import createTransition from 'shared-tokens/utils/createTransition';
import colors from 'shared-tokens/utils/tokens/colors';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as baseCls } from '../../style';

const brpM = createBreakpoint('m');

export const mainCls = `${baseCls}__fpOverlayer`;

export default {
  [mainCls]: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "100vw",
    height: "100%",
    zIndex: 31,
    overflow: "hidden",
  },
  [`${mainCls}__modale`]: {
    position: "fixed",
    // bottom: 0,
    // right: 0,
    width: "100vw",
    height: "100%",
    zIndex: 31,
    overflow: "hidden",
    opacity: 0,
    transform: "translate(0, 100%)",
    background: '#F0F2F5',
  },
  
  [`${mainCls}__modale--up`]: {
    opacity: 1,
    transform: 'translate(0, 0)',
    transition: "transform 0.3s linear, opacity 0.3s linear",
  },

  [`${mainCls}__modale--down`]: {
    transform: 'translate(0, 100%)',
    transition: "transform 0.2s linear, opacity 0.2s linear",
  },
  [`${mainCls}__body`]: {
    margin: '0 auto',
    maxWidth: 1200,
    height: '100%',
  },
  [`${mainCls}__bod`]: {
    margin: '0 auto',
    // maxWidth: 1200,
    height: '100%',
  },
  [`${mainCls}__slider`]: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  [`${mainCls}__slide`]: {
    height: '100%',
  },
  [`${mainCls}__arrowCol`]: {
    display: 'none',
    [brpM]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  [`${mainCls}__arrow`]: {
    [brpM]: {
      'display': 'flex',
      'justifyContent': 'center',
      'alignItems': 'center',
      'marginLeft': 32,
      'marginRight': 16,
      'padding': 0,
      'width': 32,
      'height': 32,
      'filter': 'drop-shadow(0 2px 4px 0 rgba(80, 90, 101, 0.3))',
      'border': '0 none',
      '&:hover': {
        color: `${colors.f0.rgba}!important`,
        filter: 'drop-shadow(1px 2px 2px rgba(0,0,0,0.5))',
      },
      '& svg': {
        marginLeft: '-2px',
        height: 14,
        pointerEvents: 'none',
      },
      '&.next': {
        'marginLeft': 16,
        'marginRight': 32,
        '& svg': {
          marginLeft: '0',
          marginRight: '-2px',
        },
      },
    },
  },
};
